import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { getLanguage, useTranslation } from 'react-multi-lang';

// Redux
import { useDispatch, useSelector } from 'react-redux';
import { client, clientsSlice, clientsState } from './ClientsSlice';
import { addClientSlice } from './AddModal/AddModalSlice';

// API
import  { sortDirectionType } from '../../services/api/api';

// Components
import TableActionBar from '../../components/TableActionBar/TableActionBar';

import { EllipsisLoader, WhiteboxLoader } from '../../components/Loader/Loader';
import { Confirm } from '../../components/Alerts/Alerts';
import AddModal from './AddModal/AddModal';

import { showClientSlice, showClient } from './ShowModal/ShowModalSlice';
import { havePermission } from '../../services/hoc/permissions';
import { Link, useNavigate } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import ClientDetail from './ShowModal/client_detail';
import {
  
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import Grid from "@mui/material/Grid"
import GreenButton from '../../components/buttons/green-button';
import { LaunchOutlined } from '@mui/icons-material';
import WhiteButton from '../../components/buttons/white-button';

import { useNotification } from '../../services/usenotification';
import { getListSort } from '../../services/hoc/sort';
import { SortTable } from '../../components/Table/SortTable';
import { RowContainer } from '../../components/Table/row_container';
import SettingContext from '../../services/context/setting-contentxt/setting-context';

import { useAPI } from '../../services/hoc/useAPI';
import { AxiosError } from 'axios';

export default () => {
  // Translation
  const t = useTranslation();
  const {alertError500}=useNotification()
  const [pagesInfo, setPagesInfo] = useState({ page: 1, lastPage: 1 });
 const keyword_ref = useRef<string|null>(null)
  // Redux
  const dispatch = useDispatch();
  const state = useSelector(
    (state: { clients: clientsState }) => state.clients,
  );
  const [clientDetail, setClientDetail] = useState<showClient>();
  const [openClientDetail, setOpenClientDetail] = useState(false);
  const sort_fields = useRef<{sort_field?:number,sort_direction?:sortDirectionType}>({})
  const navigate = useNavigate();
  const {isPc , isMobile} =useContext(SettingContext)
  // Hooks


 const ENDPOINTS = useAPI()


  // Search
  const search = (value: string) => {

    dispatch(clientsSlice.actions.reset());
     keyword_ref.current=Boolean(value)?value:null
    fetchData(1,8,Boolean(value)?value:'')
  };

  // Fetch Data
  const fetchData = useCallback((
                                  page: number
                                , page_size: number = 10
                                , keyword?:string
                                , sort_direction?:sortDirectionType
                                , sort_field?:number
                                ) => {
    dispatch(clientsSlice.actions.setIsFetching(true));
    keyword=Boolean(keyword)?keyword:keyword_ref.current?keyword_ref.current:''
    ENDPOINTS.clients()
      .index({ page, page_size, keyword,sort_direction,sort_field })
      .then((response: any) => {
        dispatch(clientsSlice.actions.setIsFetching(false));
        dispatch(clientsSlice.actions.setPage(pagesInfo.page));
        if (response.data.data.last_page)
          setPagesInfo((pre) => ({
            ...pre,
            lastPage: response.data.data.last_page,
          }));
        let clients: client[] = response.data.data.clients.map(
          (client: any): client => client,
        );

        dispatch(clientsSlice.actions.initializeClients(clients));
        dispatch(
          clientsSlice.actions.setHasMore(
            page < Number(response.data.data.last_page),
          ),
        );
        if (!state.isLoaded) dispatch(clientsSlice.actions.setIsLoaded(true));
      })
      .catch((err:AxiosError)=>{
        alertError500(err)
          dispatch(clientsSlice.actions.setIsFetching(false));
      })
  },[ENDPOINTS,dispatch,pagesInfo.page,state.isLoaded])

  const fetchSortedData =useCallback((sort_field:number,sort_direction:sortDirectionType)=>{
    if (sort_direction && sort_field){
          sort_fields.current.sort_direction=sort_direction 
      sort_fields.current.sort_field=sort_field
     
     
      fetchData(state.page,8,'',sort_direction,sort_field)
    }
  },[state.page])




  const reports =(client:client)=>(
    <div className="reports">
    <Tooltip title={t('orders')}>
      <div style={{ display: 'inline' }}>
        <i
          className="icon-orders"
          onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            navigate('/orders', { state: { key: client.name } });
            e.stopPropagation();
          }}
        />
      </div>
    </Tooltip>
    <Tooltip title={t('bills')}>
      <div style={{ display: 'inline' }}>
        <i
          className="icon-receipt"
          onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            navigate('/bills', { state: { key: client.name } });
            e.stopPropagation();
          }}
        />
      </div>
    </Tooltip>
    <Tooltip title={t('vouchers')}>
      <div style={{ display: 'inline' }}>
        <i
          className="icon-voucher"
          onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            navigate('/receipt-vouchers', {
              state: { key: client.name },
            });
            e.stopPropagation();
          }}
        />
      </div>
    </Tooltip>
  
    <Tooltip title={t('print_client_account')}>
      <Link
        to={`/spreedsheet/getclientReport/1990-01-01/${new Date().toLocaleDateString(
          'en-CA',
        )}/${client.id}`}
        data-tip={t('bills')}
        target="_blank">
        <i
          className="icon-bill"
          onClick={(e: React.MouseEvent<HTMLLIElement>) =>
            e.stopPropagation()
          }
        />
      </Link>
    </Tooltip>
    
  </div>
  )
  const actions =(client:client)=>(
    <div className="show-on-hover">
      {havePermission('Show Client') ? (
        <Tooltip title={t('info')}>

          <i
            className="icon-info"
            onClick={(e: React.MouseEvent<HTMLLIElement>) => {
              e.stopPropagation();
              fetchClientData(client.id);
              setOpenClientDetail(true);
            }}
          />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Edit Client') ? (
        <Tooltip title={t('edit')}>
        <i
          className="icon-edit"
          onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            e.stopPropagation();
            dispatch(addClientSlice.actions.setIsOpen(true));
            dispatch(addClientSlice.actions.setEditId(client.id));
            dispatch(addClientSlice.actions.setIsLoading(true));
            ENDPOINTS.clients()
              .show({ id: client.id })
              .then((response: any) => {
                dispatch(
                  addClientSlice.actions.set(response.data.data),
                );
                dispatch(addClientSlice.actions.setIsLoading(false));
              });
          }}
        />
        </Tooltip>
      ) : (
        ''
      )}
      {havePermission('Delete Client') ? (
        <Tooltip title={t('delete')}>

      
        <i
          className="icon-delete"
          onClick={(e: React.MouseEvent<HTMLLIElement>) => {
            e.stopPropagation();
            Confirm({
              message: t('delete_confirmation'),
              onConfirm: () => remove(client.id),
            });
          }}
        />
          </Tooltip>
      ) : (
        ''
      )}
    </div>
  )
  const rows =()=>{
    return (
      state.clients[state.page]
      ? state.clients[state.page]!.map((client, index) => {
        return (
          <RowContainer
          key={index} 
          item_id={client.id.toString()}
          tr_index={index}
          onSelect={toggleSelectedId}
          state_length={state.clients[state.page]?.length as number}
          columns={[
            client.serial_no,
            client.name,
            client.account_no,
            
            client.phone,
            client.email,
            reports(client),
            actions(client)
          ]}
          />
        )
      }):null
    )
  }
  const editClient = (client: any) => {
   ;
    setOpenClientDetail(false);
    dispatch(addClientSlice.actions.setIsOpen(true));
    dispatch(addClientSlice.actions.setEditId(client.id));
    dispatch(addClientSlice.actions.setIsLoading(true));
    ENDPOINTS.clients()
      .show({ id: client.id })
      .then((response: any) => {
        dispatch(addClientSlice.actions.set(response.data.data));
        dispatch(addClientSlice.actions.setIsLoading(false));
      })
      .catch((err:any)=> {
        dispatch(addClientSlice.actions.setIsLoading(false))
        alertError500(err)
      })
  };

  const generateClientData = () => {
    if (clientDetail) {
      return (
        <Grid container rowGap={2}>
          <Grid  container size={12} alignItems="end">
            <Grid  container size={6} sx={{columnGap:{xs:1,lg:0}}}>
              <Grid size={{lg:3,sm:5,xs:5}} >
                <GreenButton
                  label={t('edit_client')}
                  disabled={!havePermission('Edit Client')}
                  fun={() => 
                  editClient(clientDetail)}>
                  <i className="icon-edit" style={{ color: 'white' }} />
                </GreenButton>
              </Grid>
              <Grid size={{lg:3,sm:5,xs:5}} >
                <WhiteButton
                  label={t('delete_client')}
                  disabled={!havePermission('Delete Client')}
                  fun={() =>
                    Confirm({
                      message: t('delete_confirmation'),
                      onConfirm: () => remove(clientDetail.id),
                    })
                  }>
                  <i className="icon-delete" style={{ color: 'red' }} />
                </WhiteButton>
              </Grid>
            </Grid>
            <Grid  container size={6} columnGap={{sm:1,lg:0}} 
            alignItems={{lg:"end",sm:'center'}}
             sx={{marginBottom:{xs:'0.5rem',sm:'0'}}} >
              
              <Grid size={{lg:3,sm:3}} >

                { isMobile?
                <div className="show-on-hover" onClick={() => {
                    navigate(`/orders`, { state: { key: clientDetail.name } });
                  }}>
                 <div className='quick_link'>
                     <span>{t('orders')}</span>
                      <LaunchOutlined sx={{ 
                        color: isMobile?'var(--primary-color)':'white' ,
                        fontSize:{xs:'0.5rem',sm:'1rem'}
                        }} />
                    </div>
                    </div>
                :
                  <GreenButton
                  label={t('orders')}
                  fun={() => {
                    navigate(`/orders`, { state: { key: clientDetail.name } });
                  }}>
                  <div className="show-on-hover">
                    {/* <Link to={`/orders/clientid/${clientDetail.id}`} data-tip={t("orders")} 
                            target="_blank" state={{key:clientDetail.name}}>
                              <LaunchOutlined sx={{color:"white"}} />
                            </Link>
                            */}
                    <div>
                      <LaunchOutlined sx={{ color: 'white' }} />
                    </div>
                  </div>
                </GreenButton>}
              </Grid>
              <Grid size={{lg:3,sm:3}} >

               { isMobile?

                 <div className="show-on-hover" onClick={() => {
                    navigate(`/bills`, { state: { key: clientDetail.name } });
                  }}>
                 <div className='quick_link'>
                     <span>{t('bills')}</span>
                      <LaunchOutlined sx={{ 
                        color: isMobile?'var(--primary-color)':'white' ,
                        fontSize:{xs:'0.5rem',sm:'1rem'}
                        }} />
                    </div>
                    </div>
               :
                <GreenButton
                  label={t('bills')}
                  fun={() => {
                    navigate('/bills', { state: { key: clientDetail.name } });
                  }}>
                  <div className="show-on-hover">
                    <LaunchOutlined sx={{ color: 'white' }} />
                  </div>
                </GreenButton>
                }
              </Grid>
              <Grid size={{lg:3,sm:3}}>
             {  isMobile?
               <div className="show-on-hover" onClick={() => {
                    navigate(`/vouchers`, { state: { key: clientDetail.name } });
                  }}>
                 <div className='quick_link'>
                     <span>{t('vouchers')}</span>
                      <LaunchOutlined sx={{ 
                        color: isMobile?'var(--primary-color)':'white' ,
                        fontSize:{xs:'0.5rem',sm:'1rem'}
                        }} />
                    </div>
                    </div>
             
             :
              <GreenButton
                  label={t('vouchers')}
                  fun={() => {
                    navigate('/receipt-vouchers', {
                      state: { key: clientDetail.name },
                    });
                  }}>
                  <div className="show-on-hover">
                    <LaunchOutlined sx={{ color: 'white' }} />
                  </div>
                </GreenButton>
                }
              </Grid>
            </Grid>
          </Grid>
          <Grid  size={12} my={2}>
            <Grid  size={12}>
              <span
                style={{ fontWeight: 'bold' ,fontSize:isPc?'1rem':'0.8rem' }}
                className="primary-font-color">
                {getLanguage() === 'en'
                  ? 'Client Information'
                  : 'تفاصيل العميل'}
              </span>
            </Grid>
            <Grid size={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow sx={{
                      
                      
                        '& .MuiTableCell-root':{
                          fontSize:{sm:'0.7rem',lg:'1rem', xs:'0.5rem'},
                         
                        },
                     
                       
                      
                    }}>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Client Name' : 'اسم العميل'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en'
                          ? 'Account Number'
                          : 'رقم الحساب'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en'
                          ? 'Serial Number'
                          : 'الرقم التسلسلي'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en'
                          ? 'Tax Number'
                          : 'الرقم الضريبي'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Type' : 'النوع'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en'
                          ? 'Debt Limit'
                          : 'سقف المديونية'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Phone Number' : 'رقم الهاتف'}
                      </TableCell>

                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Phone Number' : 'رقم الجوال'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Email' : 'البريد الالكتروني'}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                          
                        '& .MuiTableCell-root':{
                          fontSize:{sm:'0.7rem',lg:'1rem',xs:'0.5rem'},
                         
                        }
                      }}>
                      <TableCell align="right">{clientDetail.name}</TableCell>

                      <TableCell align="right">
                        {clientDetail.account_no}
                      </TableCell>
                      <TableCell align="right">
                        {clientDetail.serial_no}{' '}
                      </TableCell>
                      <TableCell align="right">
                        {clientDetail.tax_number}
                      </TableCell>
                      <TableCell align="right">{clientDetail.type}</TableCell>
                      <TableCell align="right">
                        {clientDetail.debt_ceiling}
                      </TableCell>
                      <TableCell align="right">{clientDetail.phone}</TableCell>

                      <TableCell align="right">
                        {' '}
                        {clientDetail.mobile}
                      </TableCell>
                      <TableCell align="right">{clientDetail.email}</TableCell>

                      {/* <TableCell >
                                               
                                                </TableCell> */}
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
          <Grid  container size={12} rowGap={2}>
            <Grid size={12}>
              <span
                style={{ fontWeight: 'bold' }}
                className="primary-font-color">
                {getLanguage() === 'en' ? 'Client Address' : 'عنوان العميل'}
              </span>
            </Grid>
            <Grid size={12}>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow 
                    sx={
                      {  
                      '& .MuiTableCell-root':{
                        fontSize:{sm:'0.7rem',lg:'1rem',xs:'0.5rem'},
                       
                      }
                    }}
                    >
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Country' : 'الدولة'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Governate' : 'المحافظة'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'City' : 'المدينة'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en'
                          ? 'Postal Code'
                          : 'الرقم البريدي'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Flat' : 'رقم الشفة'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Address Line 1 ' : 'عنوان1'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Address Line 2' : 'عنوان2'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Address Line 3' : 'عنوان 3'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Website' : 'موقع الويب'}
                      </TableCell>
                      <TableCell sx={{ fontWeight: 'bold' }} align="right">
                        {getLanguage() === 'en' ? 'Fax' : 'الفاكس'}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow
                      sx={{
                        '&:last-child td, &:last-child th': { border: 0 },
                          
                        '& .MuiTableCell-root':{
                          fontSize:{sm:'0.7rem',lg:'1rem',xs:'0.5rem'},
                         
                        }
                      }}>
                      <TableCell align="right">
                        {clientDetail.country}
                      </TableCell>

                      <TableCell align="right">
                        {clientDetail.government}
                      </TableCell>
                      <TableCell align="right">{clientDetail.city} </TableCell>
                      <TableCell align="right">
                        {clientDetail.postal_code}
                      </TableCell>
                      <TableCell align="right">
                        {clientDetail.department_number}
                      </TableCell>
                      <TableCell align="right">
                        {' '}
                        {clientDetail.address_1}
                      </TableCell>
                      <TableCell align="right">
                        {' '}
                        {clientDetail.address_2}
                      </TableCell>
                      <TableCell align="right">
                        {clientDetail.address_3}
                      </TableCell>
                      <TableCell align="right">
                        {clientDetail.website}
                      </TableCell>
                      <TableCell align="right"> {clientDetail.fax}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </Grid>
      );
    }
    return (
      <div className="center">
        <EllipsisLoader />
      </div>
    );
  };
  const fetchClientData = (id: number) => {
    ENDPOINTS.clients()
      .show({ id })
      .then((response: any) => {
        dispatch(showClientSlice.actions.setIsLoaded(true));
        setClientDetail((pre) => ({
          name: response.data.data.name,
          account_no: response.data.data.account_no,
          serial_no: response.data.data.serial_no,
          tax_number: response.data.data.tax_number,
          phone: response.data.data.phone,
          fax: response.data.data.fax,
          mobile: response.data.data.mobile,
          email: response.data.data.email,
          website: response.data.data.website,
          country: response.data.data.country,
          government: response.data.data.government,
          city: response.data.data.city,
          postal_code: response.data.data.postal_code,
          department_number: response.data.data.department_number,
          address_1: response.data.data.address_1,
          address_2: response.data.data.address_2,
          address_3: response.data.data.address_3,
          type: response.data.data.type,
          debt_ceiling: response.data.data.debt_ceiling,
          id,
        }));
      });
  };
  // Toggle Selected id
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const toggleSelectedId = (id: number) => {
    if (!havePermission('Delete Client')) return;
    let index = selectedIds.findIndex((selectedId) => selectedId === id);
    if (index !== -1) {
      setSelectedIds(selectedIds.filter((selectedId) => selectedId !== id));
    } else setSelectedIds([...selectedIds, id]);
  };

  // Delete
  const remove = (id?: number) => {
    let ids = id ? [id] : selectedIds.map((x) => +x);
    dispatch(clientsSlice.actions.setIsLoading(true));
    ENDPOINTS.clients()
      .delete({ ids })
      .then(() => {
        setSelectedIds([]);
        dispatch(clientsSlice.actions.setIsLoading(false));
        dispatch(clientsSlice.actions.deleteClients(ids));
      });
  };

  // First fetch

  useEffect(() => {
    if (pagesInfo && pagesInfo.page !== state.page) {
      if (!state.isFetching) {
        clientsSlice.actions.setPage(pagesInfo.page);
        fetchData(pagesInfo.page,8,'',sort_fields.current.sort_direction,sort_fields.current.sort_field);
      }
    }
  }, [pagesInfo]);

useEffect(()=>{
if (!state.isFetching) fetchData(1,8,'')
},[])
  
  
  
  return (
    <>
      {state.isLoaded ? (
        <>
          {state.isLoading ? <WhiteboxLoader /> : ''}
          <TableActionBar
            title={t('clients')}
            search={search}
            showFilter={false}
            showDelete={selectedIds.length > 0}
            delete={() => {
              Confirm({
                message: t('delete_confirmation'),
                onConfirm: () => remove(),
              });
            }}
            addText={t('add_to_clients')}
            add={
              havePermission('Add Client')
                ? () => dispatch(addClientSlice.actions.setIsOpen(true))
                : undefined
            }
          />

        
          <SortTable 
           header={[
            t('client_number'),
            t('name'),
            t('reference_number'),
         
          
            t('phone'),
            t('email'),
            t('reports'),
            '',
          ]}
       
          onSelect={toggleSelectedId}
          hasMore={state.hasMore}
          loadMore={fetchData}
          pagesInfo={pagesInfo}
          setPagesInfo={setPagesInfo}
          sort_fields={getListSort(['serial_no',
            'name'
          ,'account_no','mobile','email','reports',''],'Clients')}
          fetchSortedData={fetchSortedData}
          state={state.clients[state.page]??[]}
          >
            <>
            {
              rows()
            }
            </>
          </SortTable>
          <ReactTooltip place="top" offset={10} />

          <AddModal />
          <ClientDetail
            open={openClientDetail}
            setOpen={setOpenClientDetail}
            data={generateClientData()}
          />

          {/* <ShowClient /> */}
        </>
      ) : (
        <div className="center">
          <EllipsisLoader />
        </div>
      )}
    </>
  );
};
